import React from "react";
import { CategoryDetails, Category } from "../../../types";
import ImageGallery from "react-image-gallery";

type ServicesHighlightsGalleryProps ={
    category: CategoryDetails & Category;
    disableSwipe?: boolean;
    showGalleryArrows?: boolean;
    showThumbnails?: boolean;
    showFullScreen?: boolean;
}
const ServicesHighlightsGallery = ({
                                       category,
                                       disableSwipe = true,
                                       showGalleryArrows,
                                       showThumbnails,
                                       showFullScreen
                                   }: ServicesHighlightsGalleryProps) => {

    return (
        <div className="overflow-hidden lg:p-1">
            <style>{`
                .image-gallery-slide-wrapper {
                    pointer-events: ${disableSwipe ? "none" : "auto"};
                }
                .image-gallery-left-nav,
                .image-gallery-right-nav {
                    pointer-events: auto !important;
                }
            `}</style>

            {!!category.images?.length && (
                <ImageGallery
                    items={category.images}
                    showThumbnails={showThumbnails}
                    thumbnailPosition={showThumbnails ?? category.images.length > 1 ? "left" : undefined}
                    showBullets={true}
                    showNav={showGalleryArrows}
                    showPlayButton={false}
                    showFullscreenButton={showFullScreen}
                    disableSwipe={disableSwipe}
                    autoPlay={true}
                    slideInterval={2000}
                />
            )}
        </div>
    );
};

export default ServicesHighlightsGallery;
